export const config = {
  rowSelection: true,
  columns: [
    {
      title: '产品SPU_ID',
      key: 'productId',
      dataIndex: 'productId',
      width: 200,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '产品SPU名称',
      key: 'productName',
      dataIndex: 'productName',
      width: 200,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '适用门店',
      key: 'shopName',
      dataIndex: 'shopName',
      width: 200,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '是否发包',
      key: 'allowSendPack',
      dataIndex: 'allowSendPack',
      width: 150,
      ellipsis: {
        showTitle: true,
      },
      render: v => (v ? '是' : '否'),
    },
    {
      title: '操作',
      dataIndex: 'actions',
      width: 90,
      render: 'actionRender',
      fixed: 'right',
    },
  ],
  search: [
    {
      name: 'productNameKeyword',
      label: '产品SPU名称',
    },
    {
      name: 'productId',
      label: '产品SPU_ID',
    },
    {
      name: "shopId",
      label: "适用门店",
      itemType: "select",
      key: 'id',
      labelKey: 'name',
      data: "companyOptions"
    },
  ],
  footer: [
    { label: '下载模板', render: 'exportRender' },
    { label: '导入产品', render: 'importRender' },
  ],
  batchActions: [
    {
      label: '批量删除',
      // auth: 'priceButton4',
      danger: true,
      ghost: true,
      events: ['onClick:onMultipleDelete'],
    },
  ],
}
